import _ from 'lodash';
import { FC } from 'react';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { productName } = ApplicationDomainUtility;

const TradingLevel: FC = () => {
  return (
    <section className="trading-level">
      <div className="heading-section">
        <h2>
          Built for <span className="ms-2"> Every Trading Level</span>
        </h2>
        <p>
          Whether you&apos;re starting your options journey or managing complex portfolios,{' '}
          {_.capitalize(ApplicationDomainUtility.partnerName) || productName} adapts to your needs.
        </p>
      </div>
      <div className="container">
        <div className="trading-level-cards">
          <div className="card">
            <div className="icon-circle blue-bg">
              <img src="/trading-level-1.svg" alt="Beginner Icon" />
            </div>
            <h3>Beginner Traders</h3>
            <p>
              {' '}
              Visual interface unlocks complex strategies with risk metrics, drawdown insights, and auto
              execution.
            </p>
          </div>

          <div className="card center d-lg-block d-md-none d-none">
            <div className="icon-circle green-bg">
              <img src="/trading-level-2.svg" alt="Advanced Sellers Icon" />
            </div>
            <h3>Advanced Traders</h3>
            <p>
              Dominate multi-leg setups via options baskets, premium-based rules, strategic tweaks, and
              multiple logic.
            </p>
          </div>
          <div className="card  d-lg-none d-md-block d-block">
            <div className="icon-circle green-bg">
              <img src="/trading-level-2.svg" alt="Advanced Sellers Icon" />
            </div>
            <h3>Advanced Traders</h3>
            <p>
              Dominate multi-leg setups via options baskets, premium-based rules, strategic tweaks, and
              multiple logic.
            </p>
          </div>

          <div className="card">
            <div className="icon-circle yellow-bg">
              <img src="/trading-level-4.svg" alt="API Developers Icon" />
            </div>
            <h3>Portfolio Manager </h3>
            <p>
              Track, rebalance, and optimize multiple strategy portfolios via dynamic risk tools and live
              analytics.{' '}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TradingLevel;
